import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  SecurityContext,
  ViewEncapsulation,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../config-service/app.config';
import {
  resultResModel,
} from '../../../card-operations/models/transactionCompleteResponse.model';
import { TransactionResultService } from '../../services/transaction-result/transaction-result.service';
import { TransactionResultCardOpTypes, TransactionResultModel, TransactionResultReqParamsModel } from '../../models/transaction-result-models';
import { PaymentViewModel } from './utility-classes/payment-VM';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css'],
})

export class PaymentComponent implements OnInit {

  @Input() transactionResultReqParams!: TransactionResultReqParamsModel;
  @Input() cardType!: string;
  @Input() mdStatus!: string;
  @Input() ErrMsg!: string;
  @Input() amount!: string;
  @Input() mdErrorMsg!: string;

  public transaction3dsResult = false;
  public transaction3dsResultDetail = true;

  public isLoading = true;

  public viewModel: PaymentViewModel = new PaymentViewModel(AppConfig.settings.city.currency);

  private subscriptions = new Subscription();

  constructor(
    private toastr: ToastrService,
    private transactionResultService: TransactionResultService,
  ) {}

  ngOnInit(): void {
    const transactionReqParams: TransactionResultReqParamsModel = this.transactionResultReqParams;
    this.viewModel.setTransactionRequestValues(transactionReqParams, this.amount);

    this.subscriptions.add(
      this.onTransactionResult(transactionReqParams).subscribe(transactionResult => {
        this.viewModel.setTransactionCompleteValues(transactionResult);

        this.clearStorage();
      },
      err => {
        this.toastr.error(err != null ? err : '');
        this.transaction3dsResult = false;

        this.clearStorage();
      })
    );

  }

  onTransactionResult = (transactionReqParams:TransactionResultReqParamsModel) => {
    return this.transactionResultService.transactionComplete(transactionReqParams, "etisalat")
    .pipe(
      tap((transactionResult:TransactionResultModel) => {
          this.isLoading = false;
          if (transactionResult.result.code === 0) {
            this.transaction3dsResult = true;
          } else {
            this.transaction3dsResult = false;
            this.viewModel.setInitials(transactionResult.result.message)
          }
      })
    )
  }

  private clearStorage(){
    localStorage.removeItem('payment-type')
    localStorage.removeItem('tCompleteParams')
    localStorage.removeItem('amount');
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }

}